import React from "react";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import Telecom from "../../component/solutionscomponent/Telecom";

const TelecomAndInfrastrcture = () => {
  return (
    <>
      <section className="usp_service_section">
        <Navbar />
        <Telecom />
        <Footer />
      </section>
    </>
  );
};

export default TelecomAndInfrastrcture;
